/**
 * The filters that choose which kinds of profile a search returns. Each is on by default, and the
 * frontend maps a disabled one onto the API's `hide*` transport field at the request boundary.
 *
 * A module of its own, with no imports, because the filter list reads it and the filter chips import
 * the filter list: taking it from `marketplace-search-filters` closed that loop.
 */
export const EntityTypeInclusionFilterNames = [
  "includeCompanies",
  "includeTeams",
  "includeIndividuals",
] as const;

export type EntityTypeInclusionFilterName = (typeof EntityTypeInclusionFilterNames)[number];

export function isEntityTypeInclusionFilterName(value: string): value is EntityTypeInclusionFilterName {
  return EntityTypeInclusionFilterNames.some((filterName) => filterName === value);
}
